import { ArrowRightIcon } from '@heroicons/react/24/outline'
import { ArrowUturnLeftIcon } from '@heroicons/react/24/solid'

export default function ErrorPage() {
  return (
    <>
      <div className="flex h-screen flex-col bg-white pb-12 pt-16">
        <main className="mx-auto flex w-full max-w-7xl flex-grow flex-col justify-center px-4 sm:px-6 lg:px-8">
          <div className="flex flex-shrink-0 justify-center">
            <a className="inline-flex" href="/">
              <span className="sr-only">Your Company</span>
              <img alt="" className="h-20 w-auto" src="/logo512.png" />
            </a>
          </div>
          <div className="py-10">
            <div className="text-center">
              <h1 className="mt-2 text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl">
                ¡Ups, ha ocurrido un error!
              </h1>
              <p className="mt-2 text-base text-gray-500">
                Ha ocurrido un error inesperado. Por favor, contacte con su
                administrador.
              </p>
              <div className="mt-6 flex flex-col justify-center gap-y-2">
                <a
                  className="text-base font-medium text-orange-600 hover:text-orange-500"
                  href={window.location.href}
                >
                  <span className="inline-flex items-center gap-2">
                    Ir atrás
                    <ArrowUturnLeftIcon className="h-3 font-semibold text-orange-600" />
                  </span>
                </a>
                <a
                  className="text-base font-medium text-orange-600 hover:text-orange-500"
                  href="/"
                >
                  <span className="inline-flex items-center gap-2">
                    Volver inicio
                    <ArrowRightIcon className="h-3 font-semibold text-orange-600" />
                  </span>
                </a>
              </div>
            </div>
          </div>
        </main>
      </div>
    </>
  )
}
